import { Page } from "containers/Page";
import { useContext } from "react";
import { Importar } from "./containers/Importar";
import { Resultado } from "./containers/Resultado";
import { InformeFaturamentoContext } from "./context/InformeFaturamentoContext";

export function GerenciarEmplacamentosInformeFaturamento() {
  const { loading } = useContext(InformeFaturamentoContext);

  return (
    <Page lastPage="Home / Backoffice" title="Gerenciar Emplacamentos" loading={loading}>
      <div className="mt-4">
        <Importar />
        <Resultado />
      </div>
    </Page>
  );
}
